// Keep gallery arrows available at both ends while using the native carousel and dots.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-mold-gallery-step]');
  if (!button) return;

  const carousel = document.getElementById(button.getAttribute('aria-controls'));
  if (!carousel?.matches('media-carousel')) return;
  const visibleItems = carousel.visibleItems;
  if (!visibleItems || visibleItems.length < 2) return;

  const step = Number(button.getAttribute('data-mold-gallery-step'));
  const nextIndex = (carousel.selectedIndexAmongVisible + step + visibleItems.length) % visibleItems.length;
  carousel.dispatchEvent(new CustomEvent('control:select', {
    bubbles: true,
    cancelable: true,
    detail: { index: carousel.items.indexOf(visibleItems[nextIndex]) }
  }));
});
